import Head from "next/head";
import { memo } from "react";

const VideoBanner = memo(({ data, children }) => {
  const videoSrc = data?.video;

  return (
    <>
      <Head>
        {videoSrc && (
          <link rel="preload" as="video" href={videoSrc} type="video/mp4" />
        )}
      </Head>
      <div className="relative w-full lg:h-screen h-screen top-0 z-[0]">
        {videoSrc ? (
          <video
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            aria-label="Background video"
            className="absolute inset-0 w-full h-full object-cover z-[0]"
          >
            <source src={videoSrc} type="video/mp4" />
            <p>Your browser does not support the video tag.</p>
          </video>
        ) : (
          <div
            className="absolute inset-0 w-full h-full object-cover bg-gray-200"
            aria-label="Video placeholder"
          >
            <p className="text-center text-gray-500">Video unavailable</p>
          </div>
        )}
        {children && <div className="z-[5]">{children}</div>}
      </div>
    </>
  );
});

VideoBanner.displayName = "VideoBanner";

export default VideoBanner;




// export default function VideoBanner({ data, children }) {
//   return (
//     <div className="relative w-full lg:h-screen h-screen top-0 z-[0]">
//       <video
//         autoPlay
//         loop
//         muted
//         playsInline
//         preload="auto"
//         aria-label="Background video"
//         className="absolute inset-0 w-full h-full object-cover z-[0]"
//       >
//         {data?.video ? (
//           <source src={data.video} type="video/mp4" />
//         ) : (
//           <p>Your browser does not support the video tag.</p>
//         )}
//       </video>
//       <div className="z-[5]">{children}</div>
//     </div>
//   );
// }


